<template>
  <div v-if="!friendsAndFamily">
    <section class="row" id="edit-column-width">
      <b-col sm="12">
        <div class="form-horizontal">
          <h6
            v-if="$store.state.wishlistType === 'wishlist'"
            class="section-heading"
          >
            Share Your Honeymoon
          </h6>
          <h6
            v-if="$store.state.wishlistType === 'giftlist'"
            class="section-heading"
          >
            Share The Holiday Plans
          </h6>

          <div class="form-group form-group-venue text-center">
            <h5
              v-if="$store.state.wishlistType === 'wishlist'"
              class="pl-2 pr-2"
            >
              Once you have a Trailfinders booking set up, you can share your
              honeymoon with your guests.
            </h5>
            <h5 v-else class="pl-2 pr-2">
              Once you have a Trailfinders booking set up, you can share your
              celebration with your guests.
            </h5>
            <b-col sm="12">
              <b-row class="pt-4 ml-1">
                <b-col sm="12">
                  <b-form-radio
                    v-if="$store.state.wishlistType === 'wishlist'"
                    v-model.trim="$store.state.user.show_honeymoon_itinerary"
                    name="isForMe"
                    value="true"
                    @change="radioChange"
                    >&nbsp;Yes I would like to share a preview of my honeymoon.<br />(
                    No costs can be seen by your guests )</b-form-radio
                  >
                  <b-form-radio
                    v-if="$store.state.wishlistType === 'giftlist'"
                    v-model.trim="$store.state.user.show_honeymoon_itinerary"
                    name="isForMe"
                    value="true"
                    @change="radioChange"
                    >&nbsp;Yes I would like to share a preview of my celebration.<br />(
                    No costs can be seen by your guests )</b-form-radio
                  >
                </b-col>
              </b-row>

              <b-row
                class="pt-4 ml-1 text-center"
                v-if="
                  $store.state.user.show_honeymoon_itinerary === true ||
                    $store.state.user.show_honeymoon_itinerary === 'true'
                "
              >
                <b-col sm="4">
                  <label v-if="$store.state.wishlistType === 'wishlist'"
                    >My Honeymoon Reference <strong>Number</strong>:</label
                  >
                  <label v-if="$store.state.wishlistType === 'giftlist'"
                    >My Celebration Reference <strong>Number</strong>:</label
                  >
                </b-col>
                <b-col sm="8">
                  <input
                    type="text"
                    class="form-control"
                    id="BookingRef"
                    placeholder="Booking Ref"
                    v-model="$store.state.user.honeymoon_booking_number"
                  />
                </b-col>
              </b-row>

              <!-- <b-row
                class="pt-4 ml-1"
                v-if="
                  $store.state.user.show_honeymoon_itinerary === true ||
                    $store.state.user.show_honeymoon_itinerary === 'true'
                "
              >
                <b-col sm="4">
                  <label v-if="$store.state.wishlistType === 'wishlist'"
                    >My Honeymoon Reference <strong>Surname</strong>:<br
                  /></label>
                  <label v-if="$store.state.wishlistType === 'giftlist'"
                    >My Celebration Reference <strong>Surname</strong>:<br
                  /></label>
                </b-col>
                <b-col sm="8">
                  <input
                    type="text"
                    class="form-control"
                    id="BookingName"
                    placeholder="Name"
                    v-model="$store.state.user.honeymoon_booking_name"
                  />
                </b-col>
              </b-row> -->

              <b-row
                class="pt-4 ml-1"
                v-if="
                  $store.state.user.show_honeymoon_itinerary === true ||
                    $store.state.user.show_honeymoon_itinerary === 'true'
                "
              >
                <b-col sm="12">
                  <p v-if="$store.state.wishlistType === 'wishlist'">
                    View a preview of the honeymoon
                    <a
                      target="_blank"
                      :href="
                        `https://www.trailfinders.com/viewtrail/viewtrail.html#/friendandfamily/${$store.state.user.honeymoon_link}`
                      "
                      >here.</a
                    >
                  </p>
                  <p v-if="$store.state.wishlistType === 'giftlist'">
                    View a preview of the celebration
                    <a
                      target="_blank"
                      :href="
                        `https://www.trailfinders.com/viewtrail/viewtrail.html#/friendandfamily/${$store.state.user.honeymoon_link}`
                      "
                      >here.</a
                    >
                  </p>
                </b-col>
              </b-row>

              <b-row class="pt-4 ml-1">
                <b-col sm="12">
                  <b-form-radio
                    v-model.trim="$store.state.user.show_honeymoon_itinerary"
                    name="isForMe2"
                    value="false"
                    @change="radioChange"
                    >&nbsp;I do not wish to show my itinerary</b-form-radio
                  >
                </b-col>
              </b-row>

              <b-row class="pt-4 ml-1 rd-flex justify-content-center">
                <b-col sm="12">
                  <b-button
                    v-if="$store.state.wishlistType === 'giftlist'"
                    class="btn btn-sm"
                    style="background-color: orange; color: white; border:none;"
                    @click="shareWishlist"
                    >Update</b-button
                  >
                  <b-button
                    v-else
                    class="btn btn-sm "
                    style="background-color: pink; color: white; border:none;"
                    @click="shareWishlist"
                    >Update</b-button
                  >
                </b-col>
              </b-row>

              <b-row class="pt-4 ml-1">
                <b-col sm="12">
                  <b-alert
                    v-if="updateError"
                    class="mt-2"
                    style="text-align:center"
                    variant="danger"
                    show
                    >There Has Been An Error Updating Your Changes</b-alert
                  >
                  <b-alert
                    v-if="bookingError"
                    class="mt-2"
                    style="text-align:center"
                    variant="danger"
                    show
                    >There has been an ERROR finding your booking, please check
                    your Reference and try again</b-alert
                  >
                  <b-alert
                    v-if="updateSuccess"
                    class="mt-2"
                    style="text-align:center"
                    variant="success"
                    show
                    >Your Changes Have Been Updated</b-alert
                  >
                </b-col>
              </b-row>
            </b-col>
          </div>

          <hr />
          <h2
            v-if="$store.state.wishlistType === 'wishlist'"
            class="section-heading"
            style="margin-bottom:3%;"
          >
            Yet to book your Honeymoon?
          </h2>
          <h2
            v-if="$store.state.wishlistType === 'giftlist'"
            class="section-heading"
            style="margin-bottom:3%;"
          >
            Yet to book your Holiday?
          </h2>

          <b-row class="text-center" align-content="center">
            <b-col sm="12">
              <p v-if="$store.state.wishlistType === 'wishlist'">
                If you are yet to book your Honeymoon please
                <a target="_blank" href="/contact">click here</a> to talk to a
                Honeymoon expert
              </p>
              <p v-if="$store.state.wishlistType === 'giftlist'">
                If you are yet to book your Holiday please
                <a target="_blank" href="/contact">click here</a> to talk to a
                travel expert
              </p>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </section>
  </div>
</template>

<script>
import { updateWishlist, getSFBooking } from "../../services/api";

export default {
  props: ["screenWidth"],
  data() {
    return {
      meta: {
        loaded: true
      },
      isForMe: "",
      arr: [],
      updateWishlistError: false,
      updateSuccess: false,
      updateError: false,
      bookingError: false,
      welcome_message: "",
      friendsAndFamily: null,
      numberOfFields: 0,
      item: {
        name: null,
        url: null
      }
    };
  },
  methods: {
    radioChange(value) {
      this.$store.state.user.show_honeymoon_itinerary = value;
      this.$store.dispatch("setUserAction", this.$store.state.user);
      return value;
    },
    async shareWishlist() {
      this.updateSuccess = false;
      this.updateError = false;
      this.bookingError = false;
      let response = await getSFBooking(
        this.$store.state.user.honeymoon_booking_number
      );
      if (response.data.error) {
        this.bookingError = true;
      } else if (response.data) {
        this.$store.state.user.honeymoon_booking_name =
          response.data.lead_surname;
        let data = {
          honeymoon_booking_name: this.$store.state.user.honeymoon_booking_name,
          honeymoon_booking_number: this.$store.state.user
            .honeymoon_booking_number,
          honeymoon_link: this.$store.state.user.honeymoon_link,
          _id: this.$store.state.user._id
        };
        if (
          this.$store.state.user.show_honeymoon_itinerary === "true" ||
          this.$store.state.user.show_honeymoon_itinerary === true
        ) {
          data.show_honeymoon_itinerary = true;
        } else {
          data.show_honeymoon_itinerary = false;
        }
        let res = await updateWishlist(
          this.$store.state.wishlistType,
          this.$store.state.user._id,
          data
        );
        if (res.error) {
          this.updateError = true;
        } else {
          this.updateSuccess = true;
          this.$store.dispatch("setUserAction", this.$store.state.user);
        }
      } else {
        this.updateError = true;
      }
    },
    formatMessage(value) {
      this.$store.state.user.welcome_message = `<p>` + value + `</p>`;
      this.$store.dispatch("setUserAction", this.$store.state.user);
      return value;
    },

    onClicker(event) {
      if (event === "plus" && this.$store.state.user.where_to_stay.length < 4) {
        this.arr.push({ name: this.item.name, url: this.item.url });
        this.$store.state.user.where_to_stay = this.arr;
        this.$store.dispatch("setUserAction", this.$store.state.user);
      } else {
        this.arr.pop();
        this.$store.state.user.where_to_stay = this.arr;
        this.$store.dispatch("setUserAction", this.$store.state.user);
      }
    }
  },
  mounted() {
    if (this.$route.params.wishlistType === "friends-and-family") {
      this.friendsAndFamily = true;
    }
    this.meta.loaded = true;
    this.arr = this.$store.state.user.where_to_stay;
    this.welcome_message = this.$store.state.user.welcome_message.replace(
      /<[^>]+>/g,
      ""
    );
    this.date = Date.now();
  }
};
</script>
